import { MessageSchema } from "@redotech/redo-agents-common/llm-messages";
import * as z from "zod";
import { onboardingV2StatusSchema } from "./get-onboardings-v2";

export const askRedoThreadRefSchema = z.object({
  threadId: z.string(),
  stepId: z.string(),
  stepLabel: z.string(),
  startedAt: z.string(),
  lastUpdatedAt: z.string(),
});
export type AskRedoThreadRef = z.infer<typeof askRedoThreadRefSchema>;

export const askRedoConversationSchema = z.object({
  threadId: z.string(),
  agentName: z.string(),
  prompt: z.string(),
  messages: z.array(MessageSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type AskRedoConversation = z.infer<typeof askRedoConversationSchema>;

export const onboardingV2DetailSchema = z.object({
  id: z.string(),
  teamId: z.string(),
  productId: z.string(),
  version: z.number(),
  status: onboardingV2StatusSchema,
  currentStepId: z.string(),
  dealSize: z.number().nullable(),
  analyticsSessionId: z.string().nullable(),
  startedAt: z.string(),
  updatedAt: z.string(),
  completedAt: z.string().nullable(),
  archivedAt: z.string().nullable(),
  archivedByUserId: z.string().nullable(),
  startedByUserId: z.string().nullable(),
  lastUpdatedByUserId: z.string().nullable(),
  stepsCompleted: z.number(),
  totalSteps: z.number(),
  totalTimeMs: z.number(),
  teamName: z.string(),
  teamDomain: z.string().nullable(),
  hubspotDealId: z.string().nullable(),
  contacted: z.boolean(),
  contactedAt: z.string().nullable(),
  contactedByEmail: z.string().nullable(),
  contactedByName: z.string().nullable(),
  formData: z.record(z.string(), z.unknown()),
  stepTimestamps: z.record(z.string(), z.unknown()),
  hubspotSync: z.unknown().nullable(),
  /** All Ask Redo thread refs stored for this onboarding, newest last. */
  askRedoThreads: z.array(askRedoThreadRefSchema),
  /** Hydrated transcripts for all stored threads, newest first. */
  askRedoConversations: z.array(askRedoConversationSchema),
});

export type OnboardingV2Detail = z.infer<typeof onboardingV2DetailSchema>;

export const getOnboardingV2Detail = {
  name: "getOnboardingV2Detail" as const,
  input: z.object({ teamId: z.string().min(1), productId: z.string().min(1) }),
  output: z.object({ detail: onboardingV2DetailSchema.nullable() }),
};

export type GetOnboardingV2DetailInput = z.infer<
  typeof getOnboardingV2Detail.input
>;
export type GetOnboardingV2DetailOutput = z.infer<
  typeof getOnboardingV2Detail.output
>;
